import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Courses = () => {
  return (
    <div className='m-1'>
      <Title text="Cursos"/>
      <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Courses